import userSettingsApi from './userSettingsApi';

const getUserSettings = async (userId: number | string) => {
  try {
    const { data } = await userSettingsApi.get(`/${encodeURIComponent(String(userId))}`);
    return data;
  } catch (error) {
    console.error('[getUserSettings] Failed:', error);
    throw error;
  }
};

export default getUserSettings;
